// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"884":"admin","933":"auth"}[chunkId] + "." + {"884":"0dd920b5","933":"0dd920b5"}[chunkId] + ".chunk.css";
};